var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_722",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#030303",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160686",
    "data-name": "Group 160686",
    transform: "translate(-527.241 -340)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160685",
    "data-name": "Group 160685",
    transform: "translate(534.241 347)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7, -7)",
    filter: "url(#Path_722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_722-2",
    "data-name": "Path 722",
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z",
    transform: "translate(7 7)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "camera-svgrepo-com",
    transform: "translate(539.566 352.566)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1939",
    "data-name": "Rectangle 1939",
    width: 13,
    height: 13,
    transform: "translate(0.434 0.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M11.126,11a1.126,1.126,0,1,0,1.126,1.126A1.126,1.126,0,0,0,11.126,11Z",
    transform: "translate(-4.397 -4.834)",
    fill: "#323232",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M13.261,6.662c0,.019,0,.038,0,.057v3.637a10.353,10.353,0,0,1-.046,1.274,1.538,1.538,0,0,1-1.458,1.458,10.352,10.352,0,0,1-1.274.046h-5.7A10.352,10.352,0,0,1,3.5,13.089a1.673,1.673,0,0,1-1.01-.448,1.673,1.673,0,0,1-.448-1.01A10.354,10.354,0,0,1,2,10.357V6.719q0-.029,0-.057a2.966,2.966,0,0,1,.048-.682A1.689,1.689,0,0,1,3.291,4.737a2.966,2.966,0,0,1,.682-.048H4.03A2.173,2.173,0,0,0,4.3,4.683.563.563,0,0,0,4.629,4.5a2.174,2.174,0,0,0,.153-.218L4.909,4.1l.038-.058a2.7,2.7,0,0,1,.578-.7,1.689,1.689,0,0,1,.46-.246A2.7,2.7,0,0,1,6.887,3H8.373a2.7,2.7,0,0,1,.9.095,1.69,1.69,0,0,1,.46.246,2.7,2.7,0,0,1,.578.7l.038.058.128.191a2.169,2.169,0,0,0,.153.218.563.563,0,0,0,.334.179,2.172,2.172,0,0,0,.266.006h.057a2.965,2.965,0,0,1,.682.048A1.689,1.689,0,0,1,13.213,5.98,2.967,2.967,0,0,1,13.261,6.662ZM5.378,8.63A2.252,2.252,0,1,1,7.63,10.883,2.252,2.252,0,0,1,5.378,8.63Z",
    transform: "translate(-0.901 -1.338)",
    fill: "#323232",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImageIcon);
export default __webpack_public_path__ + "static/media/profile-image-icon.cf5318529d18ceccb386344189d4eab8.svg";
export { ForwardRef as ReactComponent };